import { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const LOCALES = {
  title: {
    label: {
      fr: "Parcourir par",
      en: "Browse by",
    },
  },
};

const LIENS = [
  {
    type: "page",
    page: "sh",
    link: "sh-hs",
    label: {
      fr: "Commerce international par produit (SH)",
      en: "International trade data by product (HS)",
    },
  },
  {
    type: "page",
    page: "scian",
    link: "scian-naics",
    label: {
      fr: "Commerce international par industrie (SCIAN)",
      en: "International trade data by industry (NAICS)",
    },
  },
  {
    type: "break",
  },
  {
    type: "page",
    page: "definitions",
    link: "definitions",
    label: {
      fr: "Définitions",
      en: "Definitions",
    },
  },
  {
    type: "page",
    page: "remerciements",
    link: "remerciements-acknowledgments",
    label: {
      fr: "Remerciements",
      en: "Acknowledgments",
    },
  },
  {
    type: "page",
    page: "renseignements",
    link: "renseignements-information",
    label: {
      fr: "Renseignements sur les données",
      en: "Information on the data",
    },
  },
];

class Menu extends Component {
  render() {
    return (
      <div id="zone_gauche">
        <div id="menu_de_gauche">
          <nav className="menu_gauche">
            <h1 className="menu_h1_vert">
              {LOCALES.title.label[this.props.lang]}
            </h1>
            <ul>
              {LIENS.map((lien, idx) => {
                let link;
                if (lien.type === "page") {
                  link = (
                    <li
                      key={idx}
                      className={
                        this.props.activePage === lien.page
                          ? "niv_1_actif"
                          : "niv_1"
                      }
                    >
                      <Link to={`/${lien.link}`} role="button">
                        {lien.label[this.props.lang]}
                      </Link>
                    </li>
                  );
                } else if (lien.type === "break") {
                  link = <br key={idx} />;
                }

                return link;
              })}
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}

Menu.propTypes = {
  lang: PropTypes.string.isRequired,
  activePage: PropTypes.string,
};

export default Menu;
